module.exports = __webpack_public_path__ + "img/核心技术--身份证识别.e18de7f3.png";